export default __webpack_public_path__ + "static/media/1991.86ad266a.png";